import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalSendMail from "../../components/blocks/ModalSendMail";
import DefaultPage from "../../components/containers/DefaultPage";
import Logo from "../../components/Logo";
import LanguageSwitcher from "../../i18n/LanguageSwitcher";
import { useI18n } from "../../i18n/I18nProvider";
import {
  AuthContent,
  AuthCopyright,
  AuthFooter,
  AuthFooterLinks,
  AuthHeader,
  AuthHeaderActions,
  AuthHelpButton,
  AuthHero,
  AuthHeroBrand,
  AuthHeroSubtitleTail,
  AuthHeroCopy,
  AuthLogoButton,
  AuthMain,
  AuthPage,
} from "./AuthorizationBase.styles";

const AuthorizationBase = ({ children, variant = "login" }) => {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [isModalSendOpen, setIsModalSendOpen] = useState(false);
  const loginHero = {
    image: "/images/auth/login-hero.png",
    title: (
      <>
        <span>{t("Английский,")}</span> {t("который оживает на уроке")}
      </>
    ),
    subtitle: (
      <>
        {t(
          "Сотни коммуникативных уроков по возрастам, игры и учёт студентов — вы ведёте занятия, а не собираете",
        )}{" "}
        <AuthHeroSubtitleTail>{t("их с нуля")}</AuthHeroSubtitleTail>
      </>
    ),
  };
  const heroByVariant = {
    login: loginHero,
    register: {
      image: "/images/auth/register-hero.png",
      title: t("Начните преподавать по-новому"),
      subtitle: (
        <>
          {t("Присоединяйтесь к")}{" "}
          <AuthHeroBrand>
            SPEAK<span>ID</span>
          </AuthHeroBrand>{" "}
          {t("и создавайте уроки, которые запоминаются")}
        </>
      ),
    },
    recovery: loginHero,
  };
  const hero = heroByVariant[variant] ?? loginHero;

  return (
    <DefaultPage>
      <AuthPage>
        <ModalSendMail
          modalOpen={isModalSendOpen}
          setModalOpen={setIsModalSendOpen}
          email={null}
          phone={null}
          message={`${t("Добрый день!")}\n\n${t("У меня возникла проблема с регистрацией/входом на платформу SPEAKID на странице")} ${window.location.href}. ${t("Помогите, пожалуйста, разобраться.")}`}
          theme={t("Проблема с регистрацией/входом на платформе SPEAKID")}
        />
        <AuthHeader $variant={variant}>
          <AuthLogoButton type="button" onClick={() => navigate("/auth/login")}>
            <Logo />
          </AuthLogoButton>
          <AuthHeaderActions>
            <LanguageSwitcher />
            <AuthHelpButton
              type="button"
              onClick={() => setIsModalSendOpen(true)}
            >
              {t("Помощь")}
            </AuthHelpButton>
          </AuthHeaderActions>
        </AuthHeader>

        <AuthMain $variant={variant}>
          <AuthHero $variant={variant}>
            <AuthHeroCopy>
              <h2>{hero.title}</h2>
              <p>{hero.subtitle}</p>
            </AuthHeroCopy>
            <img src={hero.image} alt="" data-high-quality="true" />
          </AuthHero>
          <AuthContent $variant={variant}>{children}</AuthContent>
        </AuthMain>

        <AuthFooter $variant={variant}>
          <AuthFooterLinks>
            <a href="/offer.html">{t("Публичная оферта")}</a>
            <a href="/privacy-policy.html">{t("Политика конфиденциальности")}</a>
            <a href="/personal-data-agreement.html">
              {t("Согласие на обработку данных")}
            </a>
            <a href="https://speakid.ru/blog/" target="_blank" rel="noreferrer">
              {t("Блог")}
            </a>
          </AuthFooterLinks>
          <AuthCopyright>© SPEAKID, 2026</AuthCopyright>
        </AuthFooter>
      </AuthPage>
    </DefaultPage>
  );
};

export default AuthorizationBase;
